import { render, staticRenderFns } from "./PlacesAutocomplete.vue?vue&type=template&id=2b9d46f2&scoped=true"
import script from "./PlacesAutocomplete.vue?vue&type=script&lang=ts"
export * from "./PlacesAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d46f2",
  null
  
)

export default component.exports